import AdviserProfilesApi from '../../../../core/api/AdviserProfilesApi'
import PendingApprovalAdviserProfilesApi from '../../../../core/api/PendingApprovalAdviserProfilesApi'
import ContactNumberTypesApi from '../../../../core/api/ContactNumberTypesApi'
import {toast} from 'react-toastify'
const contactNumberTypesApi = new ContactNumberTypesApi()

const publishedProfilesApi = new AdviserProfilesApi()
const pendingApprovalAdviserProfilesApi = new PendingApprovalAdviserProfilesApi()

export const events = {
  fetch: {
    pendingApprovalProfile: {
      fetching: 'FETCHING_ADVISER_PROFILE_APPROVAL_EDITOR_CONTAINER_PENDING_APPROVAL_PROFILE',
      fetched: 'FETCHED_ADVISER_PROFILE_APPROVAL_EDITOR_CONTAINER_PENDING_APPROVAL_PROFILE'
    },
    publishedProfile: {
      fetching: 'FETCHING_ADVISER_PROFILE_APPROVAL_EDITOR_CONTAINER_PUBLISHED_PROFILE',
      fetched: 'FETCHED_ADVISER_PROFILE_APPROVAL_EDITOR_CONTAINER_PUBLISHED_PROFILE'
    },
    fetched: 'ADVISER_PROFILE_APPROVAL_EDITOR_FETCHED_BOTH_PROFILES',
    contactNumberTypes: 'PENDING_APPROVAL_CONTACT_NUMBER_TYPES_FETCHED'

  },
  edit: {
    start: 'ADVISER_PROFILE_APPROVAL_EDITOR_START_EDITING',
    stop: 'ADVISER_PROFILE_APPROVAL_EDITOR_STOP_EDITING',
    cancel: 'ADVISER_PROFILE_APPROVAL_EDITOR_CANCEL_EDITING'
  },
  submit: {
    submitting: 'ADVISER_PROFILE_APPROVAL_EDITOR_SUBMITTING',
    submitted: 'ADVISER_PROFILE_APPROVAL_EDITOR_SUBMITTED'
  },
  reset: 'ADVISER_PROFILE_APPROVAL_EDITOR_RESET'
}

const { fetch, edit, submit } = events

export const resetApprovalState = () => ({ type: events.reset })

export const actions = {
  fetch: {
    pendingApprovalProfile: {
      fetch: (adviserId) => {
        const request = pendingApprovalAdviserProfilesApi.getPendingApprovalProfile(adviserId)

        return (dispatch) => {
          dispatch({
            type: fetch.pendingApprovalProfile.fetching,
            adviserId
          })
          request.then(function (response) {
            dispatch(pendingApprovalAdviserProfilesApi
              .handleResponse(fetch.pendingApprovalProfile.fetched, response))
          })
        }
      }
    },
    publishedProfile: {
      fetch: (adviserId) => {
        const request = publishedProfilesApi.getPublishedAdviserProfile(adviserId)

        return (dispatch) => {
          dispatch({
            type: fetch.publishedProfile.fetching,
            adviserId
          })
          request.then(function (response) {
            dispatch(publishedProfilesApi
              .handleResponse(fetch.publishedProfile.fetched, response))
          })
        }
      }
    },
    fetched: () => ({
      type: fetch.fetched
    }),
    contactNumberTypes: () => {
      const request = contactNumberTypesApi.fetchingContactNumberTypes()

      return (dispatch) => {
        request.then(response => {
          dispatch(contactNumberTypesApi.handleResponse(fetch.contactNumberTypes, response))
        })
      }
    }
  },
  edit: {
    editAll: () => {
      let events = [
        'PENDING_APPROVAL_START_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS',
        'PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS',
        'START_EDITING_BLURB',
        'START_EDITING_PENDING_APPROVAL_LANGUAGES',
        'PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS',
        'PENDING_APPROVAL_START_EDITING_CLIENT_TYPES',
        'START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION',
        'PENDING_APPROVAL_START_EDITING_CONTACT_NUMBERS',
        edit.start
      ]

      return (dispatch) => {
        events.forEach((event) => {
          dispatch({
            type: event
          })
        })
      }
    },
    cancelAll: () => {
      let events = [
        'PENDING_APPROVAL_CANCEL_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS',
        'PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS',
        'PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS',
        'CANCEL_EDITING_BLURB',
        'CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES',
        'PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES',
        'CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION',
        edit.cancel
      ]

      return (dispatch) => {
        events.forEach((event) => {
          dispatch({
            type: event
          })
        })
      }
    },
    stopAll: () => {
      let events = [
        'PENDING_APPROVAL_STOP_EDITING_PUBLIC_CONTACT_EMAIL_ADDRESS',
        'PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS',
        'STOP_EDITING_BLURB',
        'STOP_EDITING_PENDING_APPROVAL_LANGUAGES',
        'PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS',
        'PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES',
        'STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION',
        edit.stop
      ]

      return (dispatch) => {
        events.forEach((event) => {
          dispatch({
            type: event
          })
        })
      }
    }
  },
  submit: {
    submitPendingApprovalProfile: (profile) => {
      const api = pendingApprovalAdviserProfilesApi
      const request = api.updatePendingApprovalAdviserProfile(profile.adviserId, profile)

      return (dispatch) => {
        dispatch({ type: submit.submitting })
        request.then((response) => {
          toast.success('Profile Saved')
          // The submit.submitted reducer case ignores the payload, so don't dispatch the raw
          // fetch Response (it tripped RTK's non-serializable-value check).
          dispatch({ type: submit.submitted })
        }).catch((error) => {
          // The save request itself may have succeeded (the success toast is shown above);
          // guard the response-handling path so a post-save error can't crash the editor
          // or leave it stuck in a submitting state.
          console.error('Pending profile save failed after submission:', error && error.message)
          dispatch({ type: submit.submitted })
        })
      }
    }
  }
}
